import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import Request from './request';

export const apiGetExpiredFiles = async (key, id, params = {}) => {
  return Request.call({
    url: `/micro/${key}/${id}/${key === 'products' ? 'files' : 'documents'}/expired`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
